


















































































































































































































































































































































































































import { Component, Vue, Ref, Watch } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import ResetPasswordDialogComponent from "@/components/common/ResetPasswordDialog.vue";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import UserBaseDialogComponent from "@/components/common/UserBaseDialog.vue";
import TooltipTextField from "@/components/common/TooltipTextField.vue";
import {
  getActiveUserId,
  isEmailAlreadyUsed,
  storeUserUpdate,
  UserUpdateReasonForFailure,
  setPasswordOfTheSharedUsers,
  blockSharedUsers,
  getActiveUser
} from "@/data/repository/UserRepository";

import User, { getAdminFlag, Role, ValidationLevel } from "@/data/models/User";
import Vehicle from "@/data/models/Vehicle";
import { compareArrays, generateRandomUuid } from "@/utils/Utils";
import { reconcileGroupMembership } from "@/utils/UserFormUtils";
import { formatUserValidationLevel } from "@/utils/LocalisationHelper";
import MultiSelectionPickerComponent from "../common/MultiSelectionPicker.vue";
import { Licence, localiceLicence } from "@/data/models/Licence";
import {
  getBranchesOfClient,
  getClientInfo,
  getProjectManagementType,
  getClientLanguage,
  getAdministratorClientId,
  hasAdministrationCapabilities,
  getMemberClientsInformationOfGroup,
  getClientId,
  getClientsAdministratorId,
  getUserAddressCountryFallbacks,
} from "@/data/repository/ClientRepository";
import { Branch } from "@/data/models/Branch";
import JoinSharedEmailAddressComponent from "./sharedemailaddress/JoinSharedEmailAddress.vue";
import UserPickerComponent from "../common/UserPickerComponent.vue";
import { UserModule } from "@/store/modules/UserModule";
import { 
  deleteSharedEmailAddressInfoForUser,
  getSharedEmailAddressInfo,
  removeUserFromSharedEmailAddressInfo
} from "@/data/repository/SharedEmailAddressRepository";
import {
  getAllVehiclesOfClient,
  observeVehicles,
  updateVehicle,
} from "@/data/repository/VehicleRepository";
import { COLOR_BUTTON_DISABLED, COLOR_BUTTON_GREEN, COLOR_BUTTON_RED } from "@/utils/colors";
import SharedEmailAddressFormComponent from "../settings/SharedEmailAddressForm.vue";
import {
  LicenceInfoOfClient,
  LicenceVersion,
} from "@/data/models/LicenceInfoOfClient";
import { getLicenceInfoForClient } from "@/data/repository/LicenceRepository";
import { getLicencesRequieredByRoleAndTabletUsage } from "@/data/models/LicenceInfoV3";
import { RecordInfo } from "@/data/models/RecordInfo";
import { formatDate } from "@/utils/DateFormatter";
import {
  getCapabilityOptionForRole,
  getRoleActive,
  getRoleLabel,
} from "@/data/models/RoleSettings";
import { UserCapability } from "@/data/models/UserCapability";
import { ClientsInfoOfGroup, ProjectManagement } from "@/data/models/Client";
import { UserCapabilityOption } from "@/data/models/UserCapabilityOption";
import LanguagePickerComponent from "../common/LanguagePickerComponent.vue";
import { changeLanguageTo, Language } from "@/i18n/Languages";
import {
  basicLicenceAccess,
  defineSharedUserAccess,
  defineSharedUserMasterClientAccess,
  editAdminAccess, 
  editAdminFlagAccess,
  editSharedEmailAddressAccess, 
  editUsersAccess, 
  editValidationAccess, 
  addressPositionAccess, 
  projectSupervisionAccess,
  skipUserDataValidationAccess, 
  vehicleManagementAccess,
  portalRoleChangeAccess,
} from "@/permissions/UserPermissions";
import { GeoLocation, PickedAddressParts, PickerAddress } from "@/utils/GeocodingService";
import { hasCoordinatesChanged, isRefusedUserSave } from "@/utils/UserFormUtils";
import AddressPositionFieldComponent from "@/components/common/AddressPositionField.vue";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { getEffectiveUser } from "@/utils/ViewAs";

@Component({
  components: {
    "user-base-dialog": UserBaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "reset-password-dialog": ResetPasswordDialogComponent,
    "multi-selection-picker": MultiSelectionPickerComponent,
    "join-shared-email-address": JoinSharedEmailAddressComponent,
    "user-picker": UserPickerComponent,
    "language-picker": LanguagePickerComponent,
    "shared-email-address-form": SharedEmailAddressFormComponent,
    "tooltip-text-field": TooltipTextField,
    "address-position-field": AddressPositionFieldComponent,
    picker: PickerDialogComponent,
  },
})
export default class UserFormComponent extends Vue {
  @Ref("userBaseDialog")
  userBaseDialogComponent!: UserBaseDialogComponent;

  @Ref("sharedEmailAddressForm")
  sharedEmailAddressForm!: SharedEmailAddressFormComponent;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  @Ref("resetPw")
  resetPasswordDialogComponent!: ResetPasswordDialogComponent;

  @Ref("joinSharedEmailAddress")
  joinSharedEmailAddressComponent!: JoinSharedEmailAddressComponent;

  @Watch("email")
  onEmailChanged(newValue: string) {
    if (this.initialEmail !== newValue) {
      this.hasEmailValueChanged = true;
    }
    else if (this.hasEmailValueChanged) {
      this.hasEmailValueChanged = false;
    }
  }

  licenceInfoOfClient: LicenceInfoOfClient = {
    licenceVersion: LicenceVersion.V2,
  };

  userRoleOptions = [
    Role.ADMIN,
    Role.PROJECT_MANAGER,
    Role.TECHNICIAN_1,
    Role.TECHNICIAN_2,
    Role.TECHNICIAN_AND_LEAK_DETECTION,
    Role.LEAK_DETECTION,
    Role.OFFICE,
    Role.CUSTOM_ROLE_1,
    Role.CUSTOM_ROLE_2,
    Role.CUSTOM_ROLE_3,
    Role.CUSTOM_ROLE_4,
    Role.CUSTOM_ROLE_5,
  ];

  userValidationLevelOptions = [
    ValidationLevel.LOW,
    ValidationLevel.NORMAL,
    ValidationLevel.STRICT,
  ];

  licenceOptions = [
    Licence.BASIC_LICENCE,
    Licence.DRYING_PROJECT_LICENCE,
    Licence.LEAK_DETECTION_PROJECT_LICENCE,
  ];

  emailError: Array<string> = [];
  initialLicences: Licence[] = [];
  lastChangedBy: RecordInfo | null = null;
  missingLicencesError: Array<string> = [];
  nicknameError: Array<string> = [];
  role: Role | null = Role.OFFICE;
  roleError: Array<string> = [];
  supervisorError: Array<string> = [];
  staffNumberError: Array<string> = [];
  selectableSupervisors: User[] = [];
  selectedBranches: Branch[] = [];
  initialSelectedBranches: Branch[] = [];
  selectedLicences: Licence[] = [];
  sharedEmailAddressId: string | null = null;
  subscriptions: Array<() => void> = [];
  supervisorId: string | null = null;
  temporaryPasswordError: Array<string> = [];
  user: User | null = null;
  userRoleOptionsFiltered: Role[] = [];
  validationLevel = ValidationLevel.NOT_SPECIFIED;
  validationLevelError: Array<string> = [];
  vehicles: Vehicle[] = [];
  memberClientIds: string[] = [getClientId()];
  clientsInfoOfGroup = new Map<string, ClientsInfoOfGroup>();
  vehiclesOfClient: Vehicle[] = [];
  homeClient = getClientId();

  /**
   * Membership baselines as loaded, after reconciling against the current group. `hasDataChanged`
   * compares against these instead of the raw stored values, so dropping an id that no longer
   * belongs to the group does not open the dialog in a dirty state with SICHERN enabled.
   */
  initialMemberClientIds: string[] = [getClientId()];
  initialHomeClient = getClientId();

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  allBranches = getBranchesOfClient();
  blockUser = false;
  /**
   * Position of the user's address, or null when none is stored yet.
   *
   * Null is the "not set" value the save path turns into an omitted field, which is what
   * lets IRES Cloud geocode the address itself when nobody opened the map.
   */
  coordinates: GeoLocation | null = null;
  email = "";
  enableCockpit = true;
  enableCockpitOptions = [true, false];
  firstName = "";
  initialEmail = "";
  initialNickname = "";
  wasSetToAdmin = false;
  isLoading = false;
  lastName = "";
  mobilePhone = "";
  nickname = "";
  postalCode = "";
  canChangeAdminFlag = false;
  canChangeValidationLevel = false;
  readonly = false;
  resetUserPassword = false;
  showSelectNothingOption = false;
  showingSuccessSnackbar = false;
  snackbarColor = "green";
  staffNumber = "";
  startedForUserCreation = false;
  stationaryPhone = "";
  successSnackbarText = "";
  temporaryPassword = "";
  userAddressHousenumber = "";
  userAddressStreet = "";
  userCountry = "";
  userId = "";
  userLocation = "";
  usesTablet = true;
  vehicle: Vehicle | null = null;
  vehicleAtHome = false;
  hasLicencesChanged = false;
  isSharedEmailAddress = false;
  hasJoinedSharedEmailAddress = false;
  hasEmailValueChanged = false;
  
  language: Language | undefined = undefined;
  hasLanguageChanged = false;
  /** False on the admin portal client unless the active user is a named SysAdmin. Set in show(). */
  canChangeRole = true;

  get activeUser() {
    return getActiveUser() ?? UserModule.activeUser;
  }

  /** For what the form offers (vehicles, map, validation): the chosen user while "Sicht auf" is active (ticket 2610052). */
  get effectiveUser() {
    return getEffectiveUser();
  }

  onLoading(value: boolean) {
    this.isLoading = value;
  }

  canUserBeAdmin() {
    if (this.role) {
      const hasCapability = getCapabilityOptionForRole(this.role, UserCapability.BASIC_LICENCE);

      if (hasCapability === "NO") {
        this.wasSetToAdmin = false;
        return false;
      }

      return true;
    }

    this.wasSetToAdmin = false;
    return false;
  }

  get isSaveDisabled() {
    return !this.hasDataChanged && 
      (!this.startedForUserCreation || this.temporaryPassword === "")
  }

  get nicknameLabel() {
    return this.withMandatoryMarker(
      this.$t("users.nickname").toString(),
      !this.isAllowedToSkipUserDataValidation
    );
  }

  get roleLabel() {
    return this.withMandatoryMarker(
      this.$t("users.userRole").toString(),
      !this.isAllowedToSkipUserDataValidation
    );
  }

  get validationLevelLabel() {
    return this.withMandatoryMarker(
      this.$t("users.userValidationLevel").toString(),
      true
    );
  }

  get staffNumberLabel() {
    return this.withMandatoryMarker(
      this.$t("users.staffNumber").toString(),
      !this.isAllowedToSkipUserDataValidation
    );
  }

  get emailAddressLabel() {
    return this.withMandatoryMarker(
      this.$t("users.emailAddress").toString(),
      true
    );
  }

  get temporaryPasswordLabel() {
    return this.withMandatoryMarker(
      this.$t("users.temporaryPassword").toString(),
      this.startedForUserCreation
    );
  }

  /** Appends a required marker to a label when the field is mandatory. */
  withMandatoryMarker(label: string, isMandatory: boolean) {
    return isMandatory ? `${label} *` : label;
  }

  get administratorClientId() {
    return getAdministratorClientId();
  }

  get isAllowedToViewSharedUserOptions() {
    return this.administratorClientId !== undefined ||  hasAdministrationCapabilities();
  }

  get isAllowedToDefineSharedUserAccess() {
    return defineSharedUserAccess(this.activeUser);
  }

  get isAllowedToDefineSharedUserMasterClientAccess() {
    return defineSharedUserMasterClientAccess(this.activeUser);
  }

  get isAllowedToSkipUserDataValidation() {
    return skipUserDataValidationAccess(this.effectiveUser);
  }
  
  get sortedMemberClientsInfo() {
    return Array.from(this.clientsInfoOfGroup.values())
      .sort((a: ClientsInfoOfGroup, b: ClientsInfoOfGroup) => {
        const nameA = (a.companyName || a.clientName) ?? "";
        const nameB = (b.companyName || b.clientName) ?? "";
        
        const isASelected = this.memberClientIds.includes(a.clientId);
        const isBSelected = this.memberClientIds.includes(b.clientId);

        if (isASelected && !isBSelected) return -1;
        if (!isASelected && isBSelected) return 1;

        return nameA.localeCompare(nameB);
      });
  }

  get selectedMemberClientOptions() {
    return this.sortedMemberClientsInfo
      .map(client => client.clientId)
      .filter(clientId => this.user?.clients?.includes(clientId));
  }

  getBranchId(branchNumber: string | number | null | undefined) {
    if (!branchNumber) {
      return null;
    }

    const branches = this.allBranches;
    const deviceBranch = branches.filter(branch => branchNumber.toString() === branch.branchNumber.toString());

    if (deviceBranch.length === 1) {
      return deviceBranch[0].id;
    }

    return null;
  }

  get filteredVehicleOptions() {
    return this.vehiclesOfClient
      .filter((vehicle) => {
        const vehicleBranchId = this.getBranchId(vehicle.branch);

        if (
          !vehicleBranchId || 
          !this.user?.branches ||
          this.user.branches.length === 0
        ) {
          return true;
        }

        return this.user.branches.includes(vehicleBranchId);
      });
  }

  get memberClientOptions() {
    return this.sortedMemberClientsInfo
      .filter(client => client.clientId !== this.administratorClientId || this.isAllowedToDefineSharedUserMasterClientAccess)
      .map(client => client.clientId);
  }

  get disabledOptions() {
    const clientId = getClientId();

    return [
      clientId,
      ...(this.homeClient !== clientId ? [this.homeClient] : [])
    ]
  }

  get isAllowedToEditBranches() {
    if (
      !this.getChangeAnyOption(this.activeUser) &&
      this.allBranches.length > 0
    ) {
      return true;
    }

    return false;
  }

  get defaultLanguage() {
    return this.user?.language ?? this.clientLanguage;
  }

  get isLicenceSelectionDisabled() {
    if (this.readonly) {
      return true;
    }

    return this.licenceInfoOfClient.licenceVersion !== LicenceVersion.V2;
  }

  set selectedLicencesWrapper(selectedLicences: Licence[]) {
    if (this.selectedLicences.toString() !== selectedLicences.toString()) {
      this.hasLicencesChanged = true;
    }
    this.selectedLicences = selectedLicences;
  }

  get selectedLicencesWrapper() {
    if (this.licenceInfoOfClient.licenceVersion == LicenceVersion.V2) {
      return this.selectedLicences;
    } else {
      const licenceDetailsV3 = this.licenceInfoOfClient.licenceDetailsV3;

      if (licenceDetailsV3 && this.role !== null) {
        return getLicencesRequieredByRoleAndTabletUsage(
          licenceDetailsV3,
          this.role,
          this.usesTablet
        );
      } else {
        return [];
      }
    }
  }

  get isSharedUser() {
    return this.user?.sharedUserOfGroup || this.user?.sharedEmailAddressId || this.memberClientIds.length > 1;
  }

  get shouldDisableHomeClientSelection() {
    return this.user?.homeClient !== getClientId() || this.memberClientIds.length < 2;
  }

  get formatMemberClientOptions() {
    return (clientId: string) => {
      const clientInfo = this.clientsInfoOfGroup.get(clientId);
      const name = clientInfo?.companyName ?? clientInfo?.clientName ?? null;

      return name;
    };
  }

  getVehicleName(vehicle: Vehicle) {
    return vehicle?.licencePlate ?? vehicle?.vehicleId ?? null;
  }

  nanosecondsToSeconds(nanoseconds: number) {
    return (nanoseconds / 1000000000);
  }

  secondsToMilliseconds(seconds: number) {
    return (seconds * 1000);
  }

  get lastEditInfo() {
    const lastChangedBy = this.lastChangedBy;
    
    if (lastChangedBy) {
      let date = null;
      

      if (lastChangedBy.recordedAt.nanoseconds && lastChangedBy.recordedAt.seconds) {
        const seconds = lastChangedBy.recordedAt.seconds;
        const nanoseconds = lastChangedBy.recordedAt.nanoseconds;

        const totalSeconds = seconds+this.nanosecondsToSeconds(nanoseconds);

        date = new Date(this.secondsToMilliseconds(totalSeconds));
      } 

      const dateAndTime = date ? 
      formatDate(
        date,
        "dd.MM.yyyy HH:mm"
      ) :
      formatDate(
        lastChangedBy.recordedAt.toDate(),
        "dd.MM.yyyy HH:mm"
      );
      const user = UserModule.user(lastChangedBy.recordedByUserId);

      return user
        ? this.$t("users.lastEdit", [dateAndTime, user.nickname])
        : null;
    } else {
      return null;
    }
  }

  /**
   * Initialises all form fields from a User object (edit mode) or sets
   * defaults for creation mode. Also resets error states and change tracking.
   *
   * @param user - The user to load, or `null` for creation mode.
   */
  initializeParameters(
    user: User | null
  ) {
    if (user) {
      this.sharedEmailAddressId = user.sharedEmailAddressId ?? null;
      this.supervisorId = user.supervisorId ?? null;
      this.enableCockpit = user.hasEnabledCockpit ?? false;
      this.startedForUserCreation = false;
      this.initialLicences = user.licenceInfo?.licences ?? [];
      this.userId = user.id;

      this.nickname = user.nickname;
      this.role = user.role ?? null;
      this.validationLevel =
        user.validationLevel ?? ValidationLevel.NOT_SPECIFIED;
      this.firstName = user.firstName ?? "";
      this.lastName = user.lastName ?? "";
      this.staffNumber = user.staffNumber ?? "";
      this.email = user.emailAddress ?? "";
      this.mobilePhone = user.mobilePhone ?? "";

      this.usesTablet = user.usesTablet ?? true;
      this.stationaryPhone = user.stationaryPhone ?? "";
      this.postalCode = user.postalCode ?? "";
      this.userLocation = user.location ?? "";
      this.userAddressStreet = user.addressStreet ?? "";
      this.userAddressHousenumber = user.addressHousenumber ?? "";
      this.userCountry = user.country ?? "";
      this.coordinates = user.coordinates ?? null;
      this.vehicleAtHome = user.vehicleAtHome ?? false;
      this.wasSetToAdmin = getAdminFlag(user);
      this.lastChangedBy = user.lastChangedBy ?? null;
      this.blockUser = user.blocked ?? false;
      this.vehicle = this.getUserVehicle(user) ?? null;
      this.hasLicencesChanged = false;
      this.isSharedEmailAddress = false;
      this.hasJoinedSharedEmailAddress = false;
      const membership = reconcileGroupMembership(
        user.clients,
        user.homeClient,
        Array.from(this.clientsInfoOfGroup.values()).map((client) => client.clientId),
        getClientId()
      );

      this.homeClient = membership.homeClient;
      this.memberClientIds = membership.memberClientIds;
      this.initialHomeClient = membership.homeClient;
      this.initialMemberClientIds = membership.memberClientIds;

      this.language = user.language ?? undefined;

      this.selectedBranches = this.allBranches.filter((branch) => {
        return (
          user.branches?.some((branchId) => branch.id == branchId) ?? false
        );
      });

      this.initialSelectedBranches = this.selectedBranches;
      this.userRoleOptionsFiltered = this.userRoleOptions.filter((role) =>
        getRoleActive(role, this) || this.isRoleDeviceManager(role)
      );

    } else {
      this.startedForUserCreation = true;
      this.sharedEmailAddressId = null;
      this.isSharedEmailAddress = false;

      this.supervisorId = null;
      this.enableCockpit = false;
      this.initialLicences = [];
      this.userId = generateRandomUuid();

      this.nickname = "";
      this.role = Role.OFFICE;
      this.validationLevel = ValidationLevel.NOT_SPECIFIED;

      this.firstName = "";
      this.lastName = "";
      this.staffNumber = "";
      this.email = "";
      this.mobilePhone = "";
      this.temporaryPassword = "";
      this.homeClient = getClientId();
      this.memberClientIds = [getClientId()];
      this.initialHomeClient = getClientId();
      this.initialMemberClientIds = [getClientId()];
    }

    this.selectedLicences = this.initialLicences;
    this.selectableSupervisors = UserModule.usersForSelection.filter(
      (user) => user.id !== this.userId && projectSupervisionAccess(user)
    );

    this.resetErrors();
    
    this.initialEmail = this.email;
    this.initialNickname = this.nickname;

    this.hasLanguageChanged = false;
    this.hasEmailValueChanged = false;
  }

  getUserVehicle(user?: User | null) {
    if (!user) {
      return null;
    }

    return this.vehiclesOfClient.find(vehicle => vehicle.id === user.vehicle) ?? null;
  }

  get hasDataChanged() {
    if (!this.user) {
      return false;
    }

    if (
      this.nickname !== (this.user.nickname ?? "") ||
      this.firstName !== (this.user.firstName ?? "") ||
      this.lastName !== (this.user.lastName ?? "") ||
      this.role !== (this.user.role ?? Role.OFFICE) ||
      this.wasSetToAdmin !== getAdminFlag(this.user) ||
      this.usesTablet !== (this.user.usesTablet ?? true) ||
      this.enableCockpit !== (this.user.hasEnabledCockpit ?? false) ||
      this.staffNumber !== (this.user.staffNumber ?? "") ||
      this.email !== (this.user.emailAddress ?? "") ||
      this.mobilePhone !== (this.user.mobilePhone ?? "") ||
      this.stationaryPhone !== (this.user.stationaryPhone ?? "") ||
      this.postalCode !== (this.user.postalCode ?? "") ||
      this.userLocation !== (this.user.location ?? "") ||
      this.userAddressStreet !== (this.user.addressStreet ?? "") ||
      this.userAddressHousenumber !== (this.user.addressHousenumber ?? "") ||
      this.userCountry !== (this.user.country ?? "") ||
      this.vehicle?.id !== this.getUserVehicle(this.user)?.id ||
      this.vehicleAtHome !== (this.user.vehicleAtHome ?? false) ||
      this.validationLevel !==
        (this.user.validationLevel ?? ValidationLevel.NOT_SPECIFIED) ||
      !compareArrays(
        this.selectedBranches.map(b => b.id),
        (this.initialSelectedBranches ?? []).map(b => b.id)
      ) ||
      this.supervisorId !== (this.user.supervisorId ?? null) ||
      hasCoordinatesChanged(this.coordinates, this.user.coordinates) ||
      this.temporaryPassword !== "" ||
      this.hasLicencesChanged ||
      this.hasLanguageChanged ||
      this.homeClient !== this.initialHomeClient ||
      !compareArrays(this.initialMemberClientIds, this.memberClientIds)
    ) {
      return true;
    } else {
      return false;
    }
  }

  created() {
    this.subscriptions.push(
      observeVehicles((newVehicles) => {
        this.vehicles = newVehicles;
      })
    );

    this.userRoleOptionsFiltered = this.userRoleOptions.filter((role) =>
      getRoleActive(role, this) || this.isRoleDeviceManager(role)
    );
  }

  beforeDestroy() {
    this.subscriptions.forEach((unsubscribe) => unsubscribe());
    this.subscriptions = [];
  }

  isRoleDeviceManager(role: Role) {
    if (role === Role.CUSTOM_ROLE_5) {
      return true;
    }

    return false;
  }

  /** The user's address as currently entered, for the map affordance. */
  get enteredAddress(): PickerAddress {
    return {
      street: this.userAddressStreet,
      houseNumber: this.userAddressHousenumber,
      zipCode: this.postalCode,
      city: this.userLocation,
      country: this.userCountry,
      // Reads the branches currently selected in the form, not the stored ones, so moving a
      // user to another branch changes the lookup filter before the form is even saved.
      countryFallbacks: getUserAddressCountryFallbacks(
        this.selectedBranches.map((branch) => branch.id)
      ),
    };
  }

  /**
   * The address as stored on the user.
   *
   * A pin placed for it must not decide where the map opens once the address has been
   * edited. Absent while creating a user, which has nothing stored to compare against in
   * the first place.
   */
  /**
   * Fills in the address parts a lookup or the map found, for the ones that were left empty:
   * the postcode and city from the automatic lookup, or the whole address from a pin placed
   * on the map while the address was still empty (ticket 2610025).
   *
   * Only ever fills a blank: a value the user typed stands, even where Google disagrees.
   */
  onAddressResolved(parts: PickedAddressParts) {
    if (parts.street && !this.userAddressStreet) {
      this.userAddressStreet = parts.street;
    }

    if (parts.houseNumber && !this.userAddressHousenumber) {
      this.userAddressHousenumber = parts.houseNumber;
    }

    if (parts.zipCode && !this.postalCode) {
      this.postalCode = parts.zipCode;
    }

    if (parts.city && !this.userLocation) {
      this.userLocation = parts.city;
    }

    if (parts.country && !this.userCountry) {
      this.userCountry = parts.country;
    }
  }

  get savedAddress(): PickerAddress | undefined {
    return this.user
      ? {
        street: this.user.addressStreet,
        houseNumber: this.user.addressHousenumber,
        zipCode: this.user.postalCode,
        city: this.user.location,
        country: this.user.country,
      }
      : undefined;
  }

  onSnackbarClosed(isOpen: boolean) {
    if (!isOpen) {
      this.snackbarColor = "green";
    }
  }

  get userRoleFormatter() {
    return (role: Role) => {
      return getRoleLabel(role, this);
    };
  }

  get enableVehicleManagement() {
    return vehicleManagementAccess(this.effectiveUser);
  }

  get enableGeoEncoding() {
    return addressPositionAccess(this.effectiveUser);
  }

  get enableCockpitFormatter() {
    return (enableCockpit: boolean) => {
      return this.$t(`common.${enableCockpit ? "yes" : "no"}`).toString();
    };
  }

  /**
   * Whether the FAHRT position setting is offered at all.
   *
   * IRES's own people only, by the capability that already gates everything IRES-internal: a simulated
   * drive writes invented positions onto a real time entry, so a customer's admin has no business
   * switching one on for their crew.
   *
   * Reactive on the current user (see the lessons in CLAUDE.md), so a role change reaches it without a
   * page reload.
   */

  get clientLanguage() {
    return getClientLanguage();
  }

  getBranchName(branch: Branch) {
    return branch.name;
  }

  getLicenceName(licence: Licence) {
    return localiceLicence(licence, this);
  }

  get userValidationLevelFormatter() {
    return (validationLevel: ValidationLevel) => {
      return formatUserValidationLevel(this, validationLevel);
    };
  }

  getChangeAnyOption(user: User | null) {
    if (
      editAdminAccess(user) || 
      editUsersAccess(user)
    ) {
      return false;
    }
    return true;
  }

  doesUserHaveCapabilityToEditAdminFlag(user: User | null) {
    return editAdminFlagAccess(UserModule.activeUser, user);
  }

  doesUserHaveBasicLicence(user: User | null) {
    return basicLicenceAccess(user);
  }

  /** Maps a server-side `INVALID_FIELD` error to the corresponding form field error. */
  showInvalidFieldError(field?: string) {
    const fieldErrorMap: Record<string, () => void> = {
      nickname: () => this.nicknameError = [this.$t("users.error.invalidField.nickname").toString()],
      emailAddress: () => this.emailError = [this.$t("users.error.invalidField.email").toString()],
      role: () => this.roleError = [this.$t("users.error.invalidField.role").toString()],
      staffNumber: () => this.staffNumberError = [this.$t("users.error.invalidField.staffNumber").toString()],
    };

    const handler = field ? fieldErrorMap[field] : undefined;
    if (handler) {
      handler();
    } else {
      this.nicknameError = [this.$t("users.error.invalidField.generic").toString()];
    }
  }

  getChangeValidationLevel(user: User | null | undefined) {
    if (
      user?.id !== this.activeUser?.id ||
      editValidationAccess(user ?? null)
    ) {
      return true;
    }
    return false;
  }

  getSaveChanges(user: User | null) {
    if (
      editAdminAccess(user) ||
      editUsersAccess(user) ||
      editValidationAccess(user)
    ) {
      return false;
    }
    return true;
  }

  get isClientPartOfGroup() {
    return !!getClientsAdministratorId();
  }

  get showSharedEmailAddressButton() {
    return !!this.initialEmail && !this.isClientPartOfGroup;
  }

  get isEditSharedEmailAddressDisabled() {
    const user = this.activeUser;

    if (!user) {
      return true;
    }

    if (this.hasEmailValueChanged) {
      return true;
    }

    if (
      !(this.sharedEmailAddressId) ||
      (
        this.sharedEmailAddressId &&
        user.sharedEmailAddressId &&
        this.sharedEmailAddressId === user.sharedEmailAddressId
      ) ||
      editSharedEmailAddressAccess(this.activeUser)
    ) {
      return false;
    }

    return true;
  }

  get sharedEmailAddressButtonColor() {
    if (this.hasEmailValueChanged) {
      return COLOR_BUTTON_DISABLED;
    }

    return this.sharedEmailAddressId ? this.isEditSharedEmailAddressDisabled ? COLOR_BUTTON_DISABLED : COLOR_BUTTON_GREEN : COLOR_BUTTON_RED;
  }

  get isEmailAddressFieldDisabled() {
    return this.sharedEmailAddressId ? true : false;
  }

  get showSharedEmailAddressOptions() {
    if (this.sharedEmailAddressId && !this.isEditSharedEmailAddressDisabled) {
      return true;
    }

    return false;
  }

  get isHomeClient() {
    return !this.user?.homeClient || this.user.homeClient === getClientId();
  }

  /**
   * Opens the user form dialog for creating or editing a user.
   *
   * Loads licence info, client group membership, and vehicle data in parallel.
   * Configures the dialog buttons based on the active user's permissions and
   * whether this is a create or edit operation.
   *
   * @param user - The user to edit. If omitted, the dialog opens in creation mode.
   * @returns A Promise that resolves when the dialog is closed (currently unresolved — callers should use the `dialogClosed` event).
   */
  async show(user?: User) {
    [this.licenceInfoOfClient, this.clientsInfoOfGroup, this.vehiclesOfClient] = await Promise.all([
      getLicenceInfoForClient(),
      getMemberClientsInformationOfGroup(),
      getAllVehiclesOfClient(),
    ]);

    this.readonly = this.getChangeAnyOption(this.activeUser);
    this.canChangeRole = portalRoleChangeAccess(this.activeUser);

    this.resetUserPassword = false;

    this.selectedBranches = [];

    this.user = user ?? null;

    if (this.user && !this.isHomeClient) {
      this.readonly = true;
    }

    this.canChangeAdminFlag = this.doesUserHaveCapabilityToEditAdminFlag(this.user);
    this.canChangeValidationLevel = this.getChangeValidationLevel(user);

    if (
      this.role !== null && 
      getCapabilityOptionForRole(this.role, UserCapability.BASIC_LICENCE) === UserCapabilityOption.NO &&
      getProjectManagementType() !== ProjectManagement.DEVICES_ONLY_WEBSITE
    ) {
      this.wasSetToAdmin = false;
      this.canChangeAdminFlag = false;
    }

    this.initializeParameters(user ?? null);

    const neutralButtonText =
      this.startedForUserCreation || this.getSaveChanges(this.activeUser) || this.readonly
        ? null
        : getActiveUserId() === this.userId
          ? null
          : this.$t("users.deleteUser").toString();

    this.userBaseDialogComponent.show({
      title: this.$t(
        this.getSaveChanges(this.activeUser)
          ? "users.userData"
          : this.startedForUserCreation
            ? "users.createUser"
            : "users.editUser"
      ).toString(),
      positiveButtonText: this.getSaveChanges(this.activeUser)
        ? null
        : this.$t("common.save").toString(), //greyed out if nothing changed
      negativeButtonText: this.$t(
        this.startedForUserCreation &&
        !this.getSaveChanges(this.activeUser)
            ? "common.abort"
            : "common.close"
      ).toString(),
      neutralButtonText: neutralButtonText,

      leftButtonText: this.getSaveChanges(this.activeUser) || this.readonly
        ? null
        : this.$t("users.deleteUser").toString(), // && no exteranl access?
      midButtonText: this.readonly
        ? null
        : this.$t("users.resetUserPassword").toString(), //&& no exteranl access?
      rightButtonText: this.readonly
        ? null
        : this.blockUser
          ? this.$t("users.unlockUser").toString()
          : this.$t("users.lockUser").toString(), //

      startedForUserCreation: this.startedForUserCreation,
      persistent: true,
      closeOnSave: false,
      closeOnNeutralAction: false,
      closeOnNegativeAction: false,
      closeOnLeftAction: false,
      closeOnMidAction: false,
      closeOnRightAction: false,
      maxWidth: 800,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onCloseDialog() {
    if (this.hasDataChanged) {
      const result = await this.confirmationDialogComponent.show({
        title: this.$t("common.confirmationDialog.cancelTitle").toString(),
        message: this.$t("common.confirmationDialog.cancelMessage").toString(),
      });

      if (!result) {
        return;
      }
    }

    this.initializeParameters(this.user);
    this.userBaseDialogComponent.isShowing = false;
  }

  onDialogClosed() {
    this.$emit("dialogClosed");
  }

  /**
   * Runs a user save and turns a failure into a message instead of a stuck dialog.
   *
   * Every save here goes through the `createOrUpdateUser` callable, and none of them caught its
   * rejection, so a refused or failed save left the spinner running with nothing shown. Since
   * 2026-10-01 IRES Cloud refuses role changes and user creation on the admin portal client unless
   * the caller is a named SysAdmin, which made that common enough to need its own message.
   */
  async runUserSave(action: () => Promise<void>) {
    try {
      await action();
    } catch (error) {
      this.isLoading = false;

      SnackbarModule.showError({
        key: isRefusedUserSave(error) ? "users.error.notAllowedToChangeRole" : "users.error.saveFailed",
      });
    }
  }

  onDeleteUser() {
    return this.runUserSave(() => this.performDelete());
  }

  onSave() {
    return this.runUserSave(() => this.performSave());
  }

  onResetUserPassword(calledAfterRemovingSharedUser = false) {
    return this.runUserSave(() => this.performPasswordReset(calledAfterRemovingSharedUser));
  }

  onBlockUser() {
    return this.runUserSave(() => this.performBlock());
  }

  /**
   * Soft-deletes the user after confirmation. Also removes the user from
   * any shared email address group if applicable.
   */
  async performDelete() {
    const result = await this.confirmationDialogComponent.show({
      title: this.$t("users.deleteUser").toString(),
      message: this.$t("users.deleteUserMessage", [this.nickname]).toString(),
    });

    if (result) {
      if (this.user?.sharedEmailAddressId) {
        removeUserFromSharedEmailAddressInfo(this.user.sharedEmailAddressId, this.user.id);
      }
      this.isLoading = true;

      await storeUserUpdate(this.userId, {
        deleted: true,
        emailAddress: "",
      });

      this.isLoading = false;

      if (this.userBaseDialogComponent) {
        this.userBaseDialogComponent.isShowing = false;
      }
    }
  }

  /**
   * Validates the new email address and handles shared email address flows.
   *
   * If the email hasn't changed, skips validation. If the user was previously
   * part of a shared email address, prompts for confirmation to leave it and
   * forces a password reset. If the new email is already in use, offers to
   * join the existing shared email address (unless the client is part of a group).
   *
   * @param newEmailAddress - The new email address (already lowercased).
   * @returns An object with `isEmailValid` and optionally `sharedEmailAddressId`.
   */
  async validateNewEmailAddress(newEmailAddress: string) {
    let isEmailValid = true;

    if (newEmailAddress === this.initialEmail) {
      return {
        isEmailValid,
      };
    }

    if (this.sharedEmailAddressId) {
      const confirmedDeletion = await this.confirmationDialogComponent.show({
        title: this.$t("users.deleteSharedEmailAddressDialog.title").toString(),
        message: this.$t(
          "users.deleteSharedEmailAddressDialog.message"
        ).toString(),
        acceptMessage: this.$t("common.delete").toString(),
      });

      if (!confirmedDeletion) {
        return {
          isEmailValid: false,
        };
      }

      await deleteSharedEmailAddressInfoForUser(
        this.sharedEmailAddressId,
        this.userId
      );

      // The unwrapped call, so a failure reaches the save's own runUserSave.
      await this.performPasswordReset(true);
    }

    if (newEmailAddress === "") {
      return {
        isEmailValid,
      };
    }

    const result = await isEmailAlreadyUsed(newEmailAddress, this.userId);
    let sharedEmailAddressId: string | undefined = undefined;

    if (result.isEmailAlreadyUsed) {
      if (result.sharedEmailAddressId && !this.isClientPartOfGroup) {
        this.isLoading = false;
        this.isSharedEmailAddress = true;

        const didJoinSharedEmailAddress = await this.joinSharedEmailAddressComponent.show(
          {
            userId: this.userId,
            userNickname: this.nickname.trim(),
            sharedEmailAddressId: result.sharedEmailAddressId,
            emailAddress: this.email,
            clientName: getClientInfo()?.companyName ?? "",
            createdBy: this.activeUser?.id ?? "",
          }
        );

        if (didJoinSharedEmailAddress) {
          sharedEmailAddressId = result.sharedEmailAddressId;
          isEmailValid = true;
        } else {
          isEmailValid = false;
        }
      } else {
        isEmailValid = false;
        this.emailError = [this.$t("users.error.emailAlreadyUsed").toString()];
      }
    }

    return {
      isEmailValid,
      sharedEmailAddressId,
    };
  }

  resetErrors() {
    this.nicknameError = [];
    this.roleError = [];
    this.supervisorError = [];
    this.staffNumberError = [];
    this.validationLevelError = [];
    this.emailError = [];
    this.temporaryPasswordError = [];
    this.missingLicencesError = [];
  }

  /**
   * Handles the save action: validates form fields, checks email uniqueness,
   * persists the user update via Cloud Function, updates vehicle allocations,
   * and handles error display.
   */
  async performSave() {
    const nickname = this.nickname.trim();
    let isInputValid = true;
    this.isLoading = true;
    this.resetErrors();

    if (!this.email || !this.email.trim()) {
      this.emailError = [this.$t("users.error.missingEmailAddress").toString()];
      isInputValid = false;
    }

    if (!nickname && !this.isAllowedToSkipUserDataValidation) {
      this.nicknameError = [this.$t("users.error.missingNickname").toString()];
      isInputValid = false;
    }

    if (this.validationLevel === ValidationLevel.NOT_SPECIFIED) {
      this.validationLevelError = [
        this.$t("users.error.missingValidationLevel").toString(),
      ];
      isInputValid = false;
    }

    if (!this.role && !this.isAllowedToSkipUserDataValidation) {
      this.roleError = [this.$t("users.error.missingRole").toString()];
      isInputValid = false;
    }

    if (
      (this.startedForUserCreation || this.resetUserPassword) &&
      this.temporaryPassword.length < 8
    ) {
      this.temporaryPasswordError = [
        this.$t("users.error.passwordToShort").toString(),
      ];
      isInputValid = false;
    }

    if (!this.staffNumber && !this.isAllowedToSkipUserDataValidation) {
      this.staffNumberError = [this.$t("users.error.missingStaffNumber").toString()];
      isInputValid = false;
    }

    if (this.supervisorId && !projectSupervisionAccess(UserModule.user(this.supervisorId))) {
      this.supervisorError = [this.$t("users.error.invalidSupervisor").toString()];
      isInputValid = false;
    }

    if (!isInputValid) {
      this.isLoading = false;
      return;
    }

    let newSharedEmailAddressId: string | undefined = undefined;
    let newPasswordHashHex: string | undefined = undefined;
    let newSalt: string | undefined = undefined;

    if (isInputValid) {
      const {
        isEmailValid,
        sharedEmailAddressId
      } = await this.validateNewEmailAddress(this.email.toLowerCase());

      isInputValid = isEmailValid;
      newSharedEmailAddressId = sharedEmailAddressId;

      if (isEmailValid && newSharedEmailAddressId !== undefined) {
        const sharedEmailAddressInfo = await getSharedEmailAddressInfo(newSharedEmailAddressId);

        if (sharedEmailAddressInfo) {
          this.hasJoinedSharedEmailAddress = true;
          
          newPasswordHashHex = sharedEmailAddressInfo.passwordHashHex;
          newSalt = sharedEmailAddressInfo.salt;
        }
      }
      
      this.isLoading = true;
    }
    
    if (isInputValid) {
      // eslint-disable-next-line
      const userUpdate = {
        id: this.userId,
        nickname: nickname,
        role: this.role,
        validationLevel: this.validationLevel,
        firstName: this.firstName,
        lastName: this.lastName,
        staffNumber: this.staffNumber,
        emailAddress: this.email === "" ? null : this.email.toLowerCase(),
        mobilePhone: this.mobilePhone,
        branches: this.selectedBranches.map((branch) => branch.id),
        clients: this.memberClientIds,
        homeClient: this.homeClient,
        sharedUserOfGroup: this.memberClientIds.length > 1,
        hasEnabledCockpit: this.enableCockpit,
        supervisorId: this.supervisorId,
        ...(newSharedEmailAddressId
          ? { sharedEmailAddressId: newSharedEmailAddressId }
          : {}),
        wasSetToAdmin: this.wasSetToAdmin,
        usesTablet: this.usesTablet,
        stationaryPhone: this.stationaryPhone,
        postalCode: this.postalCode,
        location: this.userLocation,
        addressStreet: this.userAddressStreet,
        addressHousenumber: this.userAddressHousenumber,
        country: this.userCountry,
        // Omitted rather than sent as null when there is no position. The user document is
        // written with a merge, and IRES Cloud only geocodes the address itself when the
        // field is absent: an explicit null would read as "already looked up, no result"
        // and suppress the automatic lookup forever.
        ...(this.coordinates ? { coordinates: this.coordinates } : {}),
        vehicle: this.vehicle?.id ?? null,
        vehicleAtHome: this.vehicleAtHome,
        ...(this.hasLanguageChanged
          ? {
            language: this.language
          }
          : {}
        ),
        ...(this.hasJoinedSharedEmailAddress
          ? {
              passwordHashHex: newPasswordHashHex,
              salt: newSalt,
              hasTemporaryPassword: false,
            }
          : {}),
        ...(this.licenceInfoOfClient.licenceVersion === LicenceVersion.V2
          ? {
              licenceInfo: {
                licences: this.selectedLicences,
                ...(this.user?.licenceInfo?.portalSessionToken
                  ? { portalSessionToken: this.user.licenceInfo.portalSessionToken }
                  : {}),
              },
            }
          : {}),
      };
      
      const temporaryPassword = this.startedForUserCreation || this.resetUserPassword
        ? this.temporaryPassword
        : undefined;

      const result = await storeUserUpdate(
        this.userId,
        userUpdate,
        temporaryPassword && !this.hasJoinedSharedEmailAddress
          ? temporaryPassword
          : undefined,
        this.readonly
      );


      if (!result.wasSuccessful) {
        if (
          this.startedForUserCreation &&
          newSharedEmailAddressId !== undefined
        ) {
          await removeUserFromSharedEmailAddressInfo(
            newSharedEmailAddressId,
            this.userId
          );
        }

        this.isLoading = false;

        if (result.reasonForFailure) {
          switch (result.reasonForFailure) {
            case UserUpdateReasonForFailure.NICKNAME_ALREADY_USED: {
              this.nicknameError = [
                this.$t("users.error.nicknameAlreadyTaken").toString(),
              ];
              break;
            }
            case UserUpdateReasonForFailure.STAFF_NUMBER_ALREADY_USED: {
              this.staffNumberError = [
                this.$t("users.error.staffNumberAlreadyTaken").toString(),
              ];
              break;
            }
            case UserUpdateReasonForFailure.LICENCE_LIMIT_EXCEEDED: {
              this.missingLicencesError = [
                this.$t("assignLicences.errorMissingLicences", [
                  (result.exceededLicences ?? [])
                    .map((licence) => this.getLicenceName(licence as Licence))
                    .join(", "),
                ]).toString(),
              ];
              break;
            }
            case UserUpdateReasonForFailure.EMAIL_ALREADY_USED: {
              this.emailError = [
                this.$t("users.error.emailAlreadyUsed").toString(),
              ];
              break;
            }
            case UserUpdateReasonForFailure.INVALID_FIELD: {
              this.showInvalidFieldError(result.field);
              break;
            }
          }
        }

        return;
      }
      else {
        if (this.vehicle?.id !== this.user?.vehicle) {
          const vehicleToBeAdded = this.vehiclesOfClient.find(vehicle => vehicle.id === this.vehicle?.id);
          const vehicleToBeRemoved = this.vehiclesOfClient.find(vehicle => vehicle.id === this.user?.vehicle);

          const promises: Promise<void>[] = [];
          if (vehicleToBeAdded) {
            promises.push(updateVehicle({
              ...vehicleToBeAdded,
              allocatedUser: this.user?.id ?? null
            }));
          }

          if (vehicleToBeRemoved) {
            promises.push(updateVehicle({
              ...vehicleToBeRemoved,
              allocatedUser: null
            }));
          }

          await Promise.all(promises);
        }

        if (this.userId === this.activeUser?.id) {
          this.user = getActiveUser();
        }
      }

      if (
        this.activeUser?.id === this.user?.id &&
        this.language &&
        this.hasLanguageChanged
      ) {
        changeLanguageTo(this.language);
      }

      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      this.userBaseDialogComponent.isShowing = false;
      
      this.resetUserPassword = false;
      this.temporaryPassword = "";
    }

    this.isLoading = false;
  }

  /**
   * Resets a user's password. For shared email address users, propagates
   * the new password to all users sharing the same email. For regular users,
   * stores the new password via Cloud Function.
   *
   * @param calledAfterRemovingSharedUser - When true, hides the "back" button
   *   and returns early after setting the password fields (used during email change flow).
   */
  async performPasswordReset(calledAfterRemovingSharedUser = false) {
    const password = await this.resetPasswordDialogComponent.show({
      title: this.$t("users.resetUserPassword").toString(),
      message: this.$t("users.resetUserPasswordMsg", [
        this.firstName,
        this.lastName,
      ]).toString(),
      rejectMessage: calledAfterRemovingSharedUser ? null : this.$t("common.back").toString(),
      acceptMessage: this.$t("common.save").toString(),
    });
    if (password !== "") {
      this.isLoading = true;
      this.temporaryPassword = password;
      this.resetUserPassword = true;

      if (calledAfterRemovingSharedUser) {
        return;
      }

      if (this.user?.sharedEmailAddressId) {
        const sharedEmailAddressInfo = await getSharedEmailAddressInfo(this.user.sharedEmailAddressId);

        if (sharedEmailAddressInfo) {
          await setPasswordOfTheSharedUsers(sharedEmailAddressInfo, this.temporaryPassword, true);
          
          this.isLoading = false;
      
          this.showingSuccessSnackbar = true;
          this.successSnackbarText = this.$t("common.changesSaved").toString();
          this.userBaseDialogComponent.isShowing = false;
          
          this.resetUserPassword = false;
          this.temporaryPassword = "";
        }
        
        return;
      }

      const result = await storeUserUpdate(
        this.userId,
        this.user,
        this.resetUserPassword ? this.temporaryPassword : undefined
      );

      if (result) {
        this.isLoading = false;
        
        if (result.wasSuccessful) {
          this.showingSuccessSnackbar = true;
          this.successSnackbarText = this.$t("common.changesSaved").toString();
          this.userBaseDialogComponent.isShowing = false;
          
          this.resetUserPassword = false;
          this.temporaryPassword = "";
        }
      }
    }
  }

  /**
   * Toggles the blocked state of a user after confirmation.
   * For shared email address users, blocks/unblocks all users sharing the email.
   */
  async performBlock() {
    const result = await this.confirmationDialogComponent.show(
      this.blockUser
        ? {
            title: this.$t("users.unlockUser").toString(),
            message: this.$t("users.unlockUserMessage", [
              this.firstName,
              this.lastName,
            ]).toString(),
            rejectMessage: this.$t("common.back").toString(),
            acceptMessage: this.$t("users.unlock").toString(),
          }
        : {
            title: this.$t("users.lockUser").toString(),
            message: this.$t("users.lockUserMessage", [
              this.firstName,
              this.lastName,
            ]).toString(),
            rejectMessage: this.$t("common.back").toString(),
            acceptMessage: this.$t("users.lock").toString(),
          }
    );

    if (result === true) {
      this.blockUser = !this.blockUser;
      this.isLoading = true;

      if (this.user?.sharedEmailAddressId) {
        const sharedEmailAddressInfo = await getSharedEmailAddressInfo(this.user.sharedEmailAddressId);

        if (sharedEmailAddressInfo) {
          await blockSharedUsers(sharedEmailAddressInfo, this.blockUser);
          
          this.isLoading = false;
      
          this.showingSuccessSnackbar = true;
          this.successSnackbarText = this.$t("common.changesSaved").toString();
          this.userBaseDialogComponent.isShowing = false;
        }
        
        return;
      }
      
      const userUpdate = {
        ...this.user,
        blocked: this.blockUser,
      };

      const temporaryPassword = this.startedForUserCreation || this.resetUserPassword
        ? this.temporaryPassword
        : undefined;

      const updateResult = await storeUserUpdate(
        this.userId,
        userUpdate,
        temporaryPassword
      );

      if (updateResult) {
        this.isLoading = false;

        if (updateResult.wasSuccessful) {
          this.showingSuccessSnackbar = true;
          this.successSnackbarText = this.$t("common.changesSaved").toString();
          this.userBaseDialogComponent.isShowing = false;
        }
      }
    }
  }

  async changeLanguage(language: Language) {
    this.hasLanguageChanged = true;
    this.language = language;
  }

  async onEditSharedEmailAddress() {
    const user = this.user;

    if (!user) {
      return;
    }

    const didUpdateSharedEmailAddress = await this.sharedEmailAddressForm.show(
      user
    );

    if (didUpdateSharedEmailAddress) {
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      this.userBaseDialogComponent.isShowing = false;
    }
  }
}
